/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Project, Project$inboundSchema } from "./project.js";

export type CreateProjectResult = {
  project: Project;
};

/** @internal */
export const CreateProjectResult$inboundSchema: z.ZodMiniType<
  CreateProjectResult,
  unknown
> = z.object({
  project: Project$inboundSchema,
});

export function createProjectResultFromJSON(
  jsonString: string,
): SafeParseResult<CreateProjectResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateProjectResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateProjectResult' from JSON`,
  );
}
